const TokenKey = 'jiazhiToken'
export default {
    getToken: function () {
        // return localStorage.getItem(TokenKey)
        return null
    },
    setToken: function (token) {
        return localStorage.setItem(TokenKey, token)
    },
   
    removeToken: function () {
        localStorage.removeItem("jz_applycode");
        localStorage.removeItem("jz_customerid");
        localStorage.removeItem("jz_incmpid");
        localStorage.removeItem("jz_incmpname");
    },
    objSetToken: function (entity) {
        entity.sessionToken = this.getToken();
        entity.token=this.getToken();
    },
    getApplyCode() {
        return localStorage.getItem("jz_applycode");
    },
    setApplycode: function (applycode) {
        return localStorage.setItem("jz_applycode", applycode)
    },
    getCustomerId() {
        return localStorage.getItem("jz_customerid");
    },
    setCustomerId: function (customerid) {
        return localStorage.setItem("jz_customerid", customerid)
    },
    getInCmpId() {
        return localStorage.getItem("jz_incmpid");
    },
    setInCmpId: function (incmpid) {
        return localStorage.setItem("jz_incmpid", incmpid)
    },
    getInCmpName() {
        return localStorage.getItem("jz_incmpname");
    },
    setInCmpName: function (incmpid) {
        return localStorage.setItem("jz_incmpname", incmpid)
    },
    getbhtype() {
        return localStorage.getItem("jz_bhtype");
    },
    setbhtype: function (bhtype) {
        return localStorage.setItem("jz_bhtype", bhtype)
    },
    getDigitalenvelope() {
        return localStorage.getItem("jz_digitalenvelope");
    },
    setDigitalenvelope: function (digitalenvelope) {
        return localStorage.setItem("jz_digitalenvelope", digitalenvelope)
    }
};



// WEBPACK FOOTER //
// ./src/utils/auth.js